module.exports = __webpack_public_path__ + "img/none.edb257c4.png";